ixModuleRouting(
    "impactx.smartform",
    {
        "/smartFormViewer": {
            template: "<ixa-smart-form-viewer-test></ixa-smart-form-viewer-test>",
            templateUrl: "shared/smartform/test/smart-form-viewer-test.html",
            controller: "SmartFormViewerTestCtrl",
            controllerAs: "smartFormViewerTestCtrl",
        },
        "/smartFormEditor": {
            template: "<ixa-smart-form-editor-test></ixa-smart-form-editor-test>",
            templateUrl: "shared/smartform/test/smart-form-editor-test.html",
            controller: "SmartFormEditorTestCtrl",
            controllerAs: "smartFormEditorTestCtrl",
        },
        "/sftlist": {
            template: "<ixa-sft-list></ixa-sft-list>",
            templateUrl: "shared/smartform/templates/sftlist.tmpl.html",
            controller: "SFTListCtrl",
            controllerAs: "sftListCtrl",
        },
        "/sfteditor/:id": {
            template: "<ixa-sft-dialog></ixa-sft-dialog>",
            templateUrl: "shared/smartform/templates/sftdialog.tmpl.html",
            controller: "SFTDialogCtrl",
            controllerAs: "sftDialogCtrl",
        },
    },
    ["ngRoute", "impactx"]
);
